import { EditTwoTone } from "@ant-design/icons";
import React from "react";

function EditTagIcon({ tags, onEdit }) {
    return <EditTwoTone onClick={() => onEdit(tags)} style={{ cursor: "pointer" }} />;
}

export default EditTagIcon;